import React, { forwardRef } from "react";
import styles from "./Button.module.scss";
import { getAllClassNames } from "helpers";

type IButton = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  disabled?: boolean;
  text: string;
  className?: string;
  replaceClassName?: string;
  color1?: string;
  color2?: string;
  ref?: React.RefObject<HTMLButtonElement>;
};

const Button = forwardRef<HTMLButtonElement | HTMLLegendElement | HTMLLabelElement, IButton>(({
  text,
  disabled,
  className,
  replaceClassName,
  color1,
  color2,  
  ...props
}, ref) => {
  return (
    <button ref={ref as React.RefObject<HTMLButtonElement>}
      {...props}
      className={getAllClassNames([
        replaceClassName || styles.button,
        disabled && styles.disabled,
        className,
      ])}
      style={
        color1 && color2
          ? {
              backgroundImage: `linear-gradient(to right, ${color1}, ${color2})`,
            }
          : undefined
      }     
    >
      {text}
    </button>
  );
});

export default Button;
